import moment from 'helpers/moment'
import { generateTypes, getCollectionActionHandlers } from 'helpers/actions'

const modelName = 'daily_product'

export function get () {
  return {
    types: generateTypes(`${modelName}s`),
    api: api => api(`${modelName}s`)
  }
}

export const actions = {
  get
}

// Action Handlers
const initialState = []
function getTempId (model) {
  return `${model.product_id}:${moment(model.date).startOf('day').valueOf()}`
}
const ACTION_HANDLERS = getCollectionActionHandlers({ modelName, getTempId })

export default function (state = initialState, action) {
  let handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/DailyProducts/modules/daily_products.js